import { render, staticRenderFns } from "./dataDownload.vue?vue&type=template&id=653610a2&scoped=true&"
import script from "./dataDownload.vue?vue&type=script&lang=js&"
export * from "./dataDownload.vue?vue&type=script&lang=js&"
import style0 from "./dataDownload.vue?vue&type=style&index=0&id=653610a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653610a2",
  null
  
)

export default component.exports